<template>
  <path pid="0" d="M7 20V6a1 1 0 00-2 0v14a1 1 0 002 0zM19.38 4.22l-10 8a1 1 0 000 1.56l10 8A1 1 0 0021 21V5a1 1 0 00-1.62-.78zM19 18.92L11.6 13 19 7.08z"/>
</template>
